/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 15:09:29
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-07-29 13:43:14
 */
import ColumnTypes from '@/utils/ColumnTypes';
import { drRoleType } from '@/utils/dataMap';

const add_time = {
	key: 'add_time',
	label: '推广时间',
	type: ColumnTypes.TextCell,
	minWidth: 120,
	fixed: 'left',
};
// const shareDimension = {
// 	key: 'type_desc',
// 	label: '分享维度',
// 	type: ColumnTypes.TextCell,
// 	minWidth: '100',
// };
const count = {
	key: 'count',
	label: '推广商品数量',
	type: ColumnTypes.TextCell,
	minWidth: '100',
};
const daren = {
	key: 'daren',
	label: drRoleType.name,
	minWidth: '150',
	type: ColumnTypes.daRenCell,
};
const view_count = {
	key: 'view_count',
	label: '查看人数',
	minWidth: '120',
	type: ColumnTypes.TextCell,
};
const anchor_name = {
	key: 'anchor_name',
	label: '达人',
	type: ColumnTypes.TextCell,
	minWidth: '100',
};
const nick_name = {
	key: 'nick_name',
	label: '达人招商',
	minWidth: '120',
	type: ColumnTypes.TextCell,
};
const is_view = {
	key: 'is_view',
	label: '是否查看',
	minWidth: '120',
	type: ColumnTypes.TextCell,
};
const view_time = {
	key: 'view_time',
	label: '查看时间',
	minWidth: '120',
	type: ColumnTypes.TextCell,
};
const info = {
	key: 'info',
	label: '查看人信息',
	type: ColumnTypes.infoCell,
	minWidth: '120',
	fixed: 'left',
};
const is_contact = {
	key: 'is_contact',
	label: '是否为联系人',
	minWidth: '120',
	type: ColumnTypes.stateCell,
};
const is_add_wx = {
	key: 'is_add_wx',
	label: '是否添加微信好友',
	minWidth: '120',
	type: ColumnTypes.stateCell,
};
const selection_count = {
	key: 'selection_count',
	label: '选品人数',
	minWidth: '120',
	type: ColumnTypes.TextCell,
};
const auth_count = {
	key: 'auth_count',
	label: '授权达人数',
	minWidth: '120',
	type: ColumnTypes.TextCell,
	helpNum: 1,
	helpDesc1: '商品库公开选品渠道做抖快账号授权的达人数',
};
const operations = {
	key: 'operations',
	label: '操作',
	minWidth: '180',
	fixed: 'right',
	type: ColumnTypes.ButtonsCell,
	align: 'right',
};

export const public_columns = [add_time, count, daren, view_count, selection_count, operations];
export const private_columns = [add_time, count, anchor_name, nick_name, is_view, view_time, operations];
export const dr_shop_columns = [info, view_time, is_contact, is_add_wx, operations];
export const tz_shop_columns = [daren, view_count, selection_count, auth_count, operations];
